import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";
import toast from "react-hot-toast";

import { FAQListItem } from "../../content.types";
import { requestUpdateFaqItem } from "./updateFaqItem.request";

const useUpdateFaqItem = (
  options?: MutationOptions<FAQListItem, ApiServiceError<ApiError>>
) => {
  const refetchFaqItems = useRefetchQuery(["content-faq"]);

  return useMutation({
    mutationFn: requestUpdateFaqItem,
    ...options,
    onSuccess: (data, variables, context) => {
      void refetchFaqItems();
      toast.success("Question updated successfully");
      options?.onSuccess?.(data, variables, context);
    }
  });
};

export default useUpdateFaqItem;
